import type { SafetyHelpLocation } from "../services/safetyHelpService";

const PRECISE_TIMEOUT_MS = 10000;
const COARSE_TIMEOUT_MS = 4000;
const COARSE_MAX_AGE_MS = 60000;

function toSafetyHelpLocation(position: GeolocationPosition): SafetyHelpLocation {
  return {
    latitude: position.coords.latitude,
    longitude: position.coords.longitude,
    ...(typeof position.coords.accuracy === "number" ? { accuracy: position.coords.accuracy } : {}),
    capturedAt: new Date().toISOString(),
  };
}

function requestPosition(options: PositionOptions): Promise<SafetyHelpLocation | null> {
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) => resolve(toSafetyHelpLocation(position)),
      () => resolve(null),
      options
    );
  });
}

export async function captureSafetyLocation(): Promise<SafetyHelpLocation | null> {
  if (typeof navigator === "undefined" || !navigator.geolocation) {
    return null;
  }

  const precise = await requestPosition({
    enableHighAccuracy: true,
    timeout: PRECISE_TIMEOUT_MS,
    maximumAge: 0,
  });
  if (precise) {
    return precise;
  }

  return requestPosition({
    enableHighAccuracy: false,
    timeout: COARSE_TIMEOUT_MS,
    maximumAge: COARSE_MAX_AGE_MS,
  });
}
